<div class="space-y-6">
  <p hlmMuted>
    Eine Agentur kann dein Konto für dich einrichten und pflegen. Dein Passwort und deine
    Anmelde-E-Mail bleiben bei dir, und du kannst die Zusammenarbeit jederzeit beenden.
  </p>

  @if (actionError()) {
    <div hlmAlert variant="destructive" role="alert">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>{{ actionError() }}</p>
    </div>
  }

  @if (loading()) {
    <div class="space-y-4" aria-busy="true" aria-label="Wird geladen">
      <hlm-skeleton class="h-32 w-full rounded-xl" />
      <hlm-skeleton class="h-48 w-full rounded-xl" />
    </div>
  } @else if (error()) {
    <div hlmAlert variant="destructive">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>{{ error() }}</p>
      <div hlmAlertAction>
        <button hlmBtn variant="outline" size="sm" type="button" (click)="load()">
          <ng-icon name="lucideRotateCw" />
          Erneut versuchen
        </button>
      </div>
    </div>
  } @else if (overview(); as o) {
    <!-- Requests first: they wait for an answer -->
    @if (o.requests.length > 0) {
      <section hlmCard aria-labelledby="access-requests-title">
        <div hlmCardHeader>
          <h2 hlmCardTitle id="access-requests-title">Anfragen</h2>
          <p hlmCardDescription>
            Diese Agenturen möchten dein Konto betreuen. Stimme nur zu, wenn du sie kennst und
            beauftragt hast.
          </p>
        </div>
        <div hlmCardContent class="space-y-3">
          @for (request of o.requests; track request.id) {
            <div hlmItem variant="outline">
              <div hlmItemContent>
                <p hlmItemTitle>{{ request.partner_name }}</p>
                <p hlmItemDescription>
                  {{ request.partner_email }} · angefragt am
                  {{ request.requested_at | date: 'dd.MM.yyyy' }}
                </p>
              </div>
              <div hlmItemActions>
                <button
                  hlmBtn
                  variant="outline"
                  size="sm"
                  type="button"
                  [disabled]="busy() !== null"
                  (click)="answer(request.id, 'reject')">
                  @if (busy() === request.id + '-reject') {
                    <hlm-spinner />
                  }
                  Ablehnen
                </button>
                <button
                  hlmBtn
                  size="sm"
                  type="button"
                  [disabled]="busy() !== null"
                  (click)="answer(request.id, 'approve')">
                  @if (busy() === request.id + '-approve') {
                    <hlm-spinner />
                  }
                  Einverstanden
                </button>
              </div>
            </div>
          }
        </div>
      </section>
    }

    <section hlmCard aria-labelledby="access-current-title">
      <div hlmCardHeader>
        <h2 hlmCardTitle id="access-current-title">Wer betreut dein Konto?</h2>
      </div>
      <div hlmCardContent>
        @if (o.current; as current) {
          <div hlmItem variant="outline">
            <div hlmItemMedia variant="icon">
              <ng-icon name="lucideHandshake" />
            </div>
            <div hlmItemContent>
              <p hlmItemTitle>{{ current.partner_name }}</p>
              <p hlmItemDescription>
                {{ current.partner_email }} ·
                {{
                  current.created_account ? 'hat dein Konto angelegt am' : 'betreut dein Konto seit'
                }}
                {{ current.since | date: 'dd.MM.yyyy' }}
              </p>
            </div>
            <div hlmItemActions>
              <button
                hlmBtn
                variant="outline"
                size="sm"
                type="button"
                [disabled]="busy() !== null"
                (click)="confirmRevoke.set(true)">
                @if (busy() === 'revoke') {
                  <hlm-spinner />
                }
                Zusammenarbeit beenden
              </button>
            </div>
          </div>
        } @else {
          <div class="flex flex-col items-center gap-2 py-6 text-center">
            <ng-icon name="lucideUserCheck" class="text-muted-foreground text-2xl" />
            <p class="font-medium">Keine Agentur betreut dein Konto</p>
            <p hlmMuted class="max-w-md text-sm">
              Arbeitest du mit einer Agentur? Sie kann dich im Schenkwerk-Partnerbereich als Kunden
              hinzufügen – du bekommst dann eine E-Mail und kannst hier zustimmen.
            </p>
          </div>
        }
      </div>
    </section>

    <section hlmCard aria-labelledby="access-log-title">
      <div hlmCardHeader>
        <h2 hlmCardTitle id="access-log-title">Änderungen durch Agenturen</h2>
        <p hlmCardDescription>Die letzten 100 Einträge, neueste zuerst.</p>
      </div>
      <div hlmCardContent>
        <app-partner-action-log [actions]="o.actions" />
      </div>
    </section>
  }
</div>

<hlm-alert-dialog
  [state]="confirmRevoke() ? 'open' : 'closed'"
  (stateChanged)="onRevokeDialogState($event)">
  <hlm-alert-dialog-content *hlmAlertDialogPortal class="max-w-lg">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>
        Zusammenarbeit mit {{ overview()?.current?.partner_name }} beenden?
      </h3>
      <p hlmAlertDialogDescription>
        Die Agentur kann dann nicht mehr in deinem Konto arbeiten. Deine Einstellungen, Produkte und
        Verkäufe bleiben, wie sie sind.
      </p>
    </div>
    <div hlmAlertDialogFooter>
      <button hlmAlertDialogCancel hlmBtn variant="outline" (click)="confirmRevoke.set(false)">
        Abbrechen
      </button>
      <button hlmAlertDialogAction hlmBtn variant="destructive" (click)="revoke()">
        Zusammenarbeit beenden
      </button>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
